import React, { useContext, useEffect } from 'react';
import CityPicker from './CityPicker';
import AsyncCityPicker from './AsyncCityPicker';
import utils from '../utils';
import InputBox from '../InputBox';
import ModifySearchContext from '../ModifySearchContext';

const SelectCity = ({
  label = 'FROM CITY',
  value = '',
  handleChange,
  cities = [],
  name = '',
  next = false,
  asyncSearch = false,
  openBox = null,
  searchButtonClicked = false,
  setsearchButtonClicked,
  landOnly = null,
  showLocationIcon = false,
  icon = { icon },
}) => {
  const { setActiveControl } = useContext(ModifySearchContext);
  useEffect(() => {
    if (openBox !== null) {
      setActiveControl(openBox);
      setsearchButtonClicked(false);
    }
  }, [openBox, searchButtonClicked]);
  const handleCityChange = city => {
    setActiveControl(next || null);
    handleChange(city, name);
  };
  return (
    <InputBox
      name={name}
      value={utils.getDisplayValue('citypicker', value)}
      label={label}
      disableInput={landOnly}
      tooltipText={`This package is starting from ${utils.getDisplayValue(
        'citypicker',
        value
      )}.<br />Starting city of this package cannot be changed.`}
      showLocationIcon={showLocationIcon}
      icon={icon}
    >
      {asyncSearch ? (
        <AsyncCityPicker value={value} handleChange={handleCityChange} cities={cities} />
      ) : (
        <CityPicker value={value} handleChange={handleCityChange} cities={cities} />
      )}
    </InputBox>
  );
};

export default SelectCity;
